import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-common-types-datalists-accordion-section',
  templateUrl: './common-types-datalists-accordion-section.component.html',
  styleUrls: ['./common-types-datalists-accordion-section.component.scss']
})
export class CommonTypesDatalistsAccordionSectionComponent implements OnInit {
  @Input() accordionWithImage: Section[] = [];
  collapsed: boolean[] = [];
  isIconTrue: boolean[] = [];
  constructor() {}

  ngOnInit(): void {
    this.accordionWithImage?.forEach((i) => {
      this.collapsed.push(false);
    });
  }

  toggleCollapsed(index: number) {
    this.collapsed[index] = !this.collapsed[index];
    this.isIconTrue[index] = !this.isIconTrue[index];
  }

  getAccordionStyle(index: number) {
    return this.collapsed[index] ? 'not-collapsed' : 'collapsed';
  }

  getArrowIcons(index: number) {
    return this.isIconTrue[index] ? 'icon-arrowUp' : 'icon-arrowDown';
  }
}
